import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { StrategyCatalogService } from '@app/pages/strategy-catalog/services/strategy-catalog.service';
import {
  StrategyItem,
  optimizeCategoryName,
  getKpiTargetsList,
} from '@app/pages/strategy-catalog/strategy-catalog.models';
import { StrategyColumns } from '@pdqdev/pdq-shared/dist/entities/StrategyCatalog';
import { ShopService } from '@app/services/shops/shop.service';
import { MAXX_METADATA_KEY } from '@app/pages/maxx/constants';

@Component({
  selector: 'impact-dashboard-before-any-abtest-winner',
  standalone: false,
  templateUrl: './impact-dashboard-before-any-abtest-winner.component.html',
  styleUrl: './impact-dashboard-before-any-abtest-winner.component.scss',
})
export class ImpactDashboardBeforeAnyAbTestWinnerComponent implements OnInit, OnDestroy {
  private shopSubscription: Subscription;

  suggestedPrompts: string[] = [
    'What should I test first?',
    'Find quick wins in my data',
    'Analyze my conversion funnel',
    'Show me revenue opportunities',
  ];

  chatInput = '';
  isMaxxEnabled = false;

  // Recipe Book
  recipeStrategies: StrategyItem[] = [];
  loadingStrategies = true;
  StrategyColumns = StrategyColumns;
  optimizeCategoryName = optimizeCategoryName;
  getKpiTargetsList = getKpiTargetsList;

  constructor(
    private router: Router,
    private strategyCatalogService: StrategyCatalogService,
    private shopService: ShopService,
  ) {}

  ngOnInit(): void {
    this.loadRecipeStrategies();
    this.checkMaxxEnabled();
  }

  private checkMaxxEnabled(): void {
    this.shopSubscription = this.shopService.shop$.subscribe((shop) => {
      this.isMaxxEnabled = !!shop?.metadata?.[MAXX_METADATA_KEY];
    });
  }

  ngOnDestroy(): void {
    if (this.shopSubscription) {
      this.shopSubscription.unsubscribe();
    }
  }

  private loadRecipeStrategies(): void {
    this.strategyCatalogService.getStrategies().subscribe({
      next: (strategies) => {
        // Get one strategy from each unique category (up to 9)
        const categoryMap = new Map<string, StrategyItem>();
        for (const strategy of strategies) {
          const category = strategy[StrategyColumns.PRIMARY_CATEGORY];
          if (!categoryMap.has(category) && categoryMap.size < 9) {
            categoryMap.set(category, strategy);
          }
        }
        this.recipeStrategies = Array.from(categoryMap.values());
        this.loadingStrategies = false;
      },
      error: () => {
        this.loadingStrategies = false;
      },
    });
  }

  navigateToStrategyDetails(item: StrategyItem): void {
    this.router.navigate(['/optimize/strategy-catalog', item[StrategyColumns.ID]]);
  }

  onViewAllStrategies(): void {
    this.router.navigate(['/optimize/strategy-catalog']);
  }

  onStartFirstTest(): void {
    this.router.navigate(['/optimize/ab-tests']);
  }

  onSuggestedPromptClick(prompt: string): void {
    this.navigateToMaxx(prompt);
  }

  onSendMessage(): void {
    if (this.chatInput.trim()) {
      this.navigateToMaxx(this.chatInput.trim());
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.onSendMessage();
    }
  }

  private navigateToMaxx(message: string): void {
    this.router.navigate(['/optimize/maxx'], {
      queryParams: { prompt: message, ref: 'impact_dashboard' },
    });
  }
}
